import reactUpdate from 'immutability-helper';
import React from 'react';

import {LegacyMeasurement} from 'constants/MeasurementConstants';
import {ContainableSummary} from 'constants/SampleConstants';
import {MeasurementType, NewMeasurementForm} from 'samples/MeasurementForm';
import {UpdateTransferModalStateHandler} from 'samples/transfers/TransferModalUtil';
import {NumericInputChangeEvent} from 'util/Types';

export interface InputContainableConcentrationFormProps {
  inputContainable: ContainableSummary;
  inputContainableConcentration: LegacyMeasurement;
  onUpdateModalState: UpdateTransferModalStateHandler;
}

class InputContainableConcentrationForm extends React.Component<InputContainableConcentrationFormProps> {
  private handleChangeValue = (e: NumericInputChangeEvent): void => {
    const inputContainableConcentration = reactUpdate(this.props.inputContainableConcentration, {
      value: {$set: e.target.numericValue},
    });
    this.props.onUpdateModalState({inputContainableConcentration});
  };

  private handleChangeUnits = ({val}: {val: string | null}): void => {
    const inputContainableConcentration = reactUpdate(this.props.inputContainableConcentration, {
      units: {$set: val},
    });
    this.props.onUpdateModalState({inputContainableConcentration});
  };

  render(): JSX.Element {
    const sharedFormProps = {
      measurement: this.props.inputContainableConcentration,
      onChangeUnits: this.handleChangeUnits,
      onChangeValue: this.handleChangeValue,
    };

    return (
      <div className="u-flex-display">
        <span className="inputContainableConcentrationForm-text">
          {`Concentration at which to transfer ${this.props.inputContainable.name}: `}
        </span>
        <NewMeasurementForm {...sharedFormProps} measurementType={MeasurementType.CONCENTRATION} />
      </div>
    );
  }
}

export default InputContainableConcentrationForm;
